var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.file != 'null' && _vm.file)?_c('vs-button',{attrs:{"color":"success","size":"small"}},[_vm._v("Download")]):_c('vs-button',{attrs:{"color":"primary","size":"small"}},[_vm._v("Upload")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }